import LinkButton from './LinkButton.js';

export default LinkButton;
